import React, {useCallback} from 'react';
import {Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap5";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import Lottie from "react-lottie";
import LoginHand from "../../../animation/login_hand.json";

const NotLoggedModal = ({afterClose, link}) => {

    const getLink = useCallback((type) => {

        if (link.indexOf("?") === -1) {
            return link + "?login=" + type;
        }

        return link + "&login=" + type;
    }, [link]);

    const lottieOptions = {
        loop: true,
        autoplay: true,
        animationData: LoginHand,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <Modal isOpen={true} toggle={afterClose} fade={true} centered={true} size="lg" contentClassName="rounded-20">
            <ModalHeader tag="div" toggle={afterClose} className="align-items-start">
                <div className="d-flex align-content-center">
                    <Lottie options={lottieOptions} height={50} width={50} />
                    <h1 className="modal-title text-22 text-start my-auto ps-3">
                        <FormattedMessage defaultMessage="Než budete pokračovat je potřeba se přihlásit, nebo registrovat"/>
                    </h1>
                </div>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs={12} lg={6} className="text-center">
                        <h2 className="text-center text-18">
                            <FormattedMessage defaultMessage="Mám účet"/>
                        </h2>
                        <p className="mt-3 text-14 ps-2 mb-4 text-center">
                            <FormattedMessage
                                defaultMessage="Pokud máte účet na webu Škola s{nbsp}nadhledem nebo webech Fraus, prosím přihlaste se." values={{ nbsp: <React.Fragment>&nbsp;</React.Fragment> }}/>
                        </p>
                        <a href={getLink('login')} className="btn btn--blue btn--bolder mb-3">
                            <FormattedMessage defaultMessage="Přihlásit se"/>
                        </a>
                    </Col>
                    <Col xs={12} lg={6} className="text-center mt-3 mt-lg-0">
                        <h2 className="text-center text-18">
                            <FormattedMessage defaultMessage="Nemám účet"/>
                        </h2>
                        <p className="mt-3 text-14 ps-2 mb-4 text-center">
                            <FormattedMessage
                                defaultMessage="Pokud zatím žádný účet nemáte, projděte prosím rychlou registrací."/>
                        </p>
                        <a href={getLink('registration')} className="btn btn--blue btn--bolder mb-3">
                            <FormattedMessage defaultMessage="Registrovat se"/>
                        </a>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className=" justify-content-start mt-2 mt-lg-5">
                <svg id="icon_info" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path id="Path_4961" data-name="Path 4961"
                          d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0M8.306,13.342c.47-1.491,1.36-3.277,1.517-3.728.227-.656-.176-.947-1.45.174-.082-.165-.2-.353-.283-.533,1.453-1.581,4.447-1.937,3.428.512-.636,1.529-1.091,2.562-1.351,3.358-.379,1.161.578.691,1.516-.176.127.209.169.276.3.516C9.9,15.445,7.587,15.62,8.306,13.342m3.952-6.807a1.08,1.08,0,0,1-1.467-.018.95.95,0,0,1,.137-1.384,1.082,1.082,0,0,1,1.467.018.95.95,0,0,1-.137,1.384"
                          fill="#3a3a3a"/>
                </svg>
                <span className="text-15">
                    <FormattedMessage
                        defaultMessage="Po přihlášení / registraci budete moci dokončit vámi připravenou objednávku."/>
                </span>
            </ModalFooter>
        </Modal>
    );

};

NotLoggedModal.propTypes = {
    afterClose: PropTypes.func.isRequired,
    link: PropTypes.string.isRequired
};

NotLoggedModal.defaultProps = {}

export default NotLoggedModal;
